import React, { useEffect } from "react";
import Label from "lib/Label";
import "./index.scss";
import ErrorMessage from "lib/ErrorMessage";
import { useState } from "react";
import { useDispatch } from "react-redux";
const InputTags = (props) => {
  const {
    placeholder,
    label,
    value,
    onChange,
    rows,
    cols,
    maxLength,
    className,
    label_style,
    tooltip,
    name,
    size,
    validators,
    autofocus,
    isEditable,
    setSelectedData,
    delimitter,
    selectedData,
    clearFieldError,
    error,
  } = props;
  const dispatch = useDispatch();
  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";
  const [inputValue, setInputValue] = useState("");
  const [limitReached, setLimitReached] = useState(false);
  const [minLengthError, setMinLengthError] = useState(false);

  
  const handleInputChange = (e) => {
    var regex_pattern = new RegExp(validators?.pattern);
    if(e.target.value == "" || regex_pattern?.test(e.target.value)){
    setInputValue(e.target.value);
    }
  };

  const handleInputKeyDown = (e) => {
    let textLength = 0
    selectedData[name]?.map((item) => {
      textLength = textLength + item?.length;
    });   
    let maxLimit = textLength + inputValue?.length
    if (maxLimit > parseInt(validators?.max_length)) {
      setLimitReached(true);
    } else  if(maxLimit < parseInt(validators?.max_length)){
      setMinLengthError(true);
    }else{
      setLimitReached(false);
      setMinLengthError(false);

    }
    if (!limitReached) {
      if ( e.key === delimitter) {
        const newTag = inputValue?.trim();
        if (newTag) {
          setInputValue("");
          if(selectedData[name]){
            dispatch(setSelectedData({ key: name, value: [...selectedData[name], newTag] }));
          }
          else{
            dispatch(setSelectedData({ key: name, value: [newTag] }));

          }
        } else {
          setInputValue("");
        }
      }
    }
  };

  const handleTagDelete = (indexToRemove) => {
    const updatedTags = selectedData[name]?.filter((key, index) => index !== indexToRemove);
    dispatch(setSelectedData({ key: name, value: updatedTags }));
  };
  return (
    <>
      <div className={`col-12  ${errorClass}`}>
        <Label label={label} className={label_style} tooltip={tooltip}  validators={validators} />
        <div className="form-input border p-2 pb-1">
          <div className="d-flex flex-wrap align-items-baseline">
            {selectedData[name]?.length > 0 && selectedData[name]?.map((tag, index) => (
              <div
                className={`bg-theme-grey px-2 py-1 d-flex align-items-center fs-15px rounded-1 mb-2 break-work-when-exceeds ;
                ${
                  index != 0 ? "ms-2" : ""
                }`}
                key={index}
              >
                {tag}
                <button
                  className="btn btn-close fs-8px mb-1 ms-2 shadow-none "
                  onClick={() => handleTagDelete(index)}
                ></button>
              </div>
            ))}
            <input
              name={name}
              placeholder={placeholder}
              autoFocus={autofocus ? true : false}
              className={`form-control border-0 shadow-none fs-15px tag-input form-textarea w-120px ${
                !isEditable && "radioDisabled"
              }  ${errorClass}`}
              value={inputValue}
              onChange={handleInputChange}
              rows={rows}
              cols={cols}
              maxLength={maxLength}
              disabled={isEditable ? false : true}
              onKeyDown={handleInputKeyDown}
            />
          </div>
        </div>
      </div>
      <div className="mt-1">
        {error?.length !== 0 && <ErrorMessage error={error} />}
        {(limitReached ) ? (
          <ErrorMessage
            error={`You can't enter more than ${validators?.max_length} characters`}
          />
        ) : (
          ""
        )}
        
      </div>
    </>
  );
};

export default InputTags;
